var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(
      _vm.currentUrl.includes('bigul.stockants.com') ||
        _vm.currentUrl.includes('maitracommodities.stockants.com') || 
        _vm.currentUrl.includes('ashlarindia-trade.stockants.com') || 
        _vm.currentUrl.includes('multigain-trade.stockants.com') || 
        _vm.currentUrl.includes('tradeplus.stockants.com') ||
        _vm.currentUrl.includes('multigain-trade.stockants.com') || 
        _vm.currentUrl.includes('skicapital.stockants.com')
    )?_c('div',[_c('BigulLoginPageVue')],1):(_vm.currentEnvironment && _vm.currentEnvironment.byPassLogin)?_c('div',{staticStyle:{"height":"100vh","width":"100%","display":"flex","align-items":"center","justify-content":"center"}},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.is_login_page_loading),expression:"is_login_page_loading"}]})]):_c('div',[_c('Login')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }